import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaTelegramPlane } from 'react-icons/fa';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 relative overflow-hidden">

      {/* Background Animation */}
      <div className="absolute inset-0 z-[-1] pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(circle_at_center,#e0f2fe_0%,transparent_70%)] opacity-40" />
        <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-200 rounded-full filter blur-3xl opacity-30 animate-float-slow" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-orange-300 rounded-full filter blur-3xl opacity-30 animate-float-slow delay-100" />
      </div>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 py-20 md:py-32 relative z-10">
        <h1 className="text-4xl md:text-6xl font-extrabold text-center text-blue-900 mb-12 animate-fade-in">
          📞 Get in Touch
        </h1>

        <div className="flex flex-col md:flex-row gap-16 items-start animate-fade-in delay-200">
          
          {/* Logo + Address */}
          <div className="flex-1 space-y-4">
            <img
              src="./images/logo.png"
              alt="INSA Logo"
              className="w-36 md:w-48 object-contain transition-transform duration-500 hover:scale-105"
            />
            <h2 className="text-2xl font-bold text-blue-800">Our Location</h2>
            <p className="text-lg text-gray-700 leading-relaxed font-medium">
              Addis Ababa, Ethiopia
              Welo Sefer<br/>
              China Street
            </p>
          </div>

          {/* Contact Links */}
          <div className="flex-1 space-y-6">
            <h2 className="text-2xl font-bold text-blue-800 mb-4">Reach Us Directly</h2>
            <div className="flex flex-col gap-4">
              <a
                href="tel:+251948165959"
                className="flex items-center gap-4 group hover:translate-x-1 transition-all"
              >
                <FaPhoneAlt className="text-blue-600 text-2xl group-hover:scale-110 transition-transform" />
                <span className="text-lg font-medium group-hover:underline">+251 (948) 165-959</span>
              </a>

              <a
                href="mailto:talent@insa.gov.et"
                className="flex items-center gap-4 group hover:translate-x-1 transition-all"
              >
                <FaEnvelope className="text-blue-600 text-2xl group-hover:scale-110 transition-transform" />
                <span className="text-lg font-medium group-hover:underline">talent@insa.gov.et</span>
              </a>

              <a
                href="https://t.me/cteinsa"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 group hover:translate-x-1 transition-all"
              >
                <FaTelegramPlane className="text-blue-600 text-2xl group-hover:scale-110 transition-transform" />
                <span className="text-lg font-medium group-hover:underline">@cteinsa</span>
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;
